<template lang="pug">
v-app
  v-container.pa-0.ma-0(fluid home)
    .home__content( v-if="noUser" ) Во время авторизации возникла ошибка. <br/> Попробуйте повторить поытку позже.
    .home__content( v-else )
      .home__content-title.mb-8 Выберите нужное из найденых судебных заседаний:
      v-hover( v-slot:default="{ hover }" v-for="acc in accounts" :key="acc.login" )
        v-card.d-inline-block.text-left.ma-4( :elevation="hover ? 10 : 5" outlined ripple @click="selectAccount(acc)" ) 
          .d-inline-block
            v-avatar( color="rgb(27, 147, 173)" size="80" tile )
              span.white--text Комната:<br/>{{ acc.roomName }}
          .d-inline-block.case.px-4
            b.case-label Дело №:
            span {{ acc.caseNumber }}<br/>
            span 
              b.case-label Судья:
              | {{ acc.judgeName }}<br/>
            span 
              b.mr-2 Назначено на:
              | {{ acc.sessionTime }}
          div.pa-3 
            span.case-number {{ acc.fio }}<br/>
            span 
              b.mr-2 Выступает в качестве:
              | {{ acc.statusName }}
    div.d-none( ref="fio" )
</template>

<script>
import { config } from '@/_helpers'
import Meeting from '@/common/Meeting'

var getParams = function (url) {
  var parser = document.createElement('a')
  parser.href = url
  
	var query = parser.search.substring(1)
  var vars = query.split('&')
  
  var params = {}
  if (vars.length == 0) return params
  
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=')
		params[pair[0]] = decodeURIComponent(pair[1])
	}
	return params
}

export default {
  mixins: [Meeting],
  props: {
    roomName: null
  },

  mounted () {
    if (!this.noUser) {
      let link = `${config.esiaPath}/user/${this.userUid}`
      fetch(link, {method: 'POST', mode: 'cors'}).then(res => res.json()).then(list => {
        this.accounts = list
      }).catch(err => console.error(err));
      // fetch(link, {method: 'POST', mode: 'cors'}).then(res => res.text()).then(fio => {
      //   this.$_meeting_setCookieForUser(this.userUid, fio, false, true)
      //   location.href = this.$_meeting_makeUrlForRoom(this.roomName)
      // }).catch(err => console.error(err));
    }
  },

  computed: {
    userUid () {
      let params = getParams(window.location.href)
      return params.uid
    },

    noUser () {
      return !this.userUid || this.userUid.length == 0
    },
  },

  methods: {
    selectAccount (acc) {
      this.$_meeting_setCookieForUser(this.userUid, acc.fio, false, true)
      location.href = this.$_meeting_makeUrlForRoom(acc.roomName)
    } 
  },

  data () {
    return {
      accounts: []
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  text-align: center;
}
.home__content {
  margin-top: 100px;
}
.home__content-title {
  font-family: $slab;
  font-size: 18px;
}
.case {
  vertical-align: bottom;
}
.case-number {
  text-decoration: underline;
}
.case-label {
  display: inline-block;
  width: 80px;
}
.case-fio {
  color: rgb(27, 147, 173);
}
</style>